import React, { useEffect, useReducer } from 'react'
import { Button, Modal } from 'react-bootstrap'

import { ToastType, useToast } from '../../../hooks/useToast'
import { useChangeDimensionsAndWeightDataForPartsMutation } from '../../../modules/store/datahubApi/datahubApi'
import { DimensionsAndWeightData } from '../../../modules/store/datahubApi/datahubTypes'
import { partReducer } from '../../../pages/NewPart/partReducer'
import { Part, partInput, PartListSearchParams } from '../../../types/part/partTypes'
import Loader from '../../_atoms/Loader/Loader'
import OverlayWithText from '../../_atoms/OverlayWithText/OverlayWithText'
import PartCreateUpdateTable from '../PartCreateUpdateTable/PartCreateUpdateTable'

import { initialPartState } from './initialPartState'
import styles from './styles.module.scss'

interface Props {
    isOpen: boolean
    closeModal: () => void
    parts: Part[]
    confirmChanges: () => void
    partListSearchParams?: PartListSearchParams
}

export const ModalChangeDimensionsAndWeight = ({
    isOpen,
    closeModal,
    parts,
    confirmChanges,
    partListSearchParams,
}: Props) => {
    const [state, dispatch] = useReducer(partReducer, initialPartState)
    const [fetchChangeDimensionsAndWeightData, { isLoading, error, data }] =
        useChangeDimensionsAndWeightDataForPartsMutation()

    const onCloseModal = () => {
        closeModal()
    }

    const confirm = async () => {
        const newPartTypeData = await getApiObjectFromState()
        if (newPartTypeData) {
            fetchChangeDimensionsAndWeightData({
                partsId: parts.map(part => part.id),
                dimensionsAndWeightData: newPartTypeData,
                params: partListSearchParams,
            })
        }
    }

    const getApiObjectFromState = async () => {
        let apiObject: DimensionsAndWeightData = {}

        state.fields.map((item: partInput) => {
            if (Number(item.value)) {
                apiObject = {
                    ...apiObject,
                    [item.field]: Math.round(Number(item.value) * 10) / 10,
                }
            }
        })

        return apiObject
    }

    useEffect(() => {
        if (data) {
            confirmChanges()
            closeModal()
        }
    }, [closeModal, confirmChanges, data])

    useToast({ isTriggered: !!error, type: ToastType.ERROR, message: 'Ошибка изменения габаритов' })
    useToast({ isTriggered: !!data, type: ToastType.SUCCESS, message: 'Запчасти успешно обновлены' })

    return (
        <Modal show={isOpen} onHide={onCloseModal} centered dialogClassName={styles.modal}>
            {isLoading && (
                <OverlayWithText backgroundBootstrapColor={'bg-secondary'}>
                    <Loader diameterInPx={100} thicknessInPx={10} />
                </OverlayWithText>
            )}
            <Modal.Header closeButton>
                <Modal.Title>
                    <b>Изменить габариты и вес с упаковкой</b>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <PartCreateUpdateTable dispatch={dispatch} fields={state.fields} />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={confirm}>
                    Сохранить
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
